module.exports = "build/assets/cardBg.da40a1f7.png";